import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesProductUsageGuides } from "../../constants";
import { ResolvedUsageGuide } from "../../productUsageGuides.types";

export const requestResolvedUsageGuide = async (
  productId: string
): Promise<ResolvedUsageGuide | null> => {
  // What the customer would actually see: the product's own guide, or the
  // nearest one up its category tree. Never compute this on the client — the
  // fallback rules live on the backend and may gain levels.
  const guide: ResolvedUsageGuide | "" | null = await instance.get(
    buildUrl(ApiRoutesProductUsageGuides.ResolvedForProduct, productId)
  );

  return guide || null;
};
